import React, { useState, useContext, useEffect } from 'react';
import Header from '../components/Header';
import Loader from '../components/Loader';
import Exit from '../components/Exit';
import { AuthContext } from '../contexts/AuthContext';
import { useParams, useNavigate } from 'react-router-dom';
import * as constants from '../constants/constants';
import { post } from '../api/Api';
import Swal from 'sweetalert2';
import Footer from '../components/Footer';
import FirmarDocumento from '../utils/FirmarDocumento';
import { ConvertirSaltosDeLinea } from '../utils/TextUtils';


function Examen() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { userData } = useContext(AuthContext);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [examen, setExamen] = useState(null);
  const [respuestas, setRespuestas] = useState({});

  const handleExit = Exit();

  const getExamen = async () => {
    setIsLoading(true);
    try {
      const formDataEnviar = new FormData();
      formDataEnviar.append('documento', userData?.documento);
      formDataEnviar.append('token', userData?.token);
      formDataEnviar.append('certificacion_id', id);

      const response = await post('obtener_certificaciones', formDataEnviar);
      if (response.data.success) {
        const examenData = response.data.data;
        examenData.preguntas = examenData.preguntas.sort(() => Math.random() - 0.5);
        setExamen(examenData);
        if (examenData.aprobado?.aprobado) {
          navigate(constants.CURSO);
        }
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      setError(error?.response?.data?.message || error.message);
      if (error?.response?.data?.code === 401) {
        handleExit();
      }
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getExamen();
  }, []);


  const handleDescargar = (fechaAprobado) => {
    Swal.close();
    FirmarDocumento(userData, fechaAprobado);
  };


  const handleChange = (preguntaId, opcion) => {
    setRespuestas(prevRespuestas => {
      const respuestasPregunta = prevRespuestas[preguntaId] || [];
      const nuevaRespuestas = respuestasPregunta.includes(opcion)
        ? respuestasPregunta.filter(r => r !== opcion)
        : [...respuestasPregunta, opcion];
      return { ...prevRespuestas, [preguntaId]: nuevaRespuestas };
    });
  };


  const handleEnviarRespuestas = async () => {
    const respuestasUsuario = Object.entries(respuestas).map(([id, respuestas]) => ({
      id,
      respuestas,
    }));

    const formDataEnviar = {
      documento: userData?.documento,
      token: userData?.token,
      certificacion_id: id,
      respuestas_usuario: respuestasUsuario,
    };

    // Mostrar popup de confirmación antes de enviar
    Swal.fire({
      title: "Confirmar envío",
      text: "¿Estás segur@ de que quieres enviar tus respuestas?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      showCloseButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showLoaderOnConfirm: true,
      reverseButtons: true,
      customClass: {
        cancelButton: 'auteco_button tertiary',
        confirmButton: 'auteco_button primary'
      },

      preConfirm: async () => {
        try {
          // Enviar la solicitud solo si el usuario confirma
          const response = await post('calificar_certificacion', formDataEnviar);
          return response;
        } catch (error) {
          console.error(error);
          Swal.showValidationMessage(error?.response?.data?.message || "Error al enviar las respuestas.");
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const response = result.value;
        if (response.data.success) {
          if (response.data.data.aprobado.aprobado) {
            navigate(constants.CURSO);
            Swal.fire({
              title: "¡Felicitaciones!",
              text: `Ahora eres un conductor con mayor conocimiento
              ¡Tu esfuerzo y dedicación dieron fruto! Ahora estás listo para conducir de una forma más segura.`,
              icon: "success",
              showConfirmButton: false,
              customClass: {
                confirmButton: 'auteco_button download'
              },
              didOpen: () => {
                const downloadButton = document.createElement('button');
                downloadButton.classList.add('auteco_button', 'download');
                downloadButton.style.width = '50%';
                downloadButton.style.margin = '2rem auto';
                downloadButton.innerHTML = `
                  <i class="material-symbols-outlined">download</i>
                  <div class="textos">
                    <div class="titulo">Conductor certificado</div>
                    <div class="subtitulo">Descarga tu diploma aquí</div>
                  </div>
                `;
                downloadButton.addEventListener('click', () => handleDescargar(response.data.data.aprobado.fecha));
                Swal.getPopup().appendChild(downloadButton);
              }
            });
          } else {
            Swal.fire({
              title: "¡Inténtalo otra vez!",
              html: `
                <p>Has obtenido un <strong>${response.data.data.porcentaje_aciertos}%</strong> de aciertos, pero necesitas al menos un <strong>${response.data.data.porcentaje_aprobacion}%</strong> para aprobar.</p>
                <p>Respondiste correctamente <strong>${response.data.data.total_preguntas_aprobadas}</strong> de <strong>${response.data.data.total_preguntas}</strong> preguntas.</p>
                <p>¡No te rindas! La perseverancia es la clave del éxito.<br>
                  Revisa el contenido y vuelve a intentarlo.
                </p>
              `,
              icon: "error",
              showCancelButton: true,
              confirmButtonText: "Repetir examen",
              cancelButtonText: "Cancelar",
              allowOutsideClick: false,
              allowEscapeKey: false,
              reverseButtons: true,
              customClass: {
                cancelButton: 'auteco_button tertiary',
                confirmButton: 'auteco_button primary'
              },
            }).then((retryResult) => {
              if (retryResult.isConfirmed) {
                // Volver al curso
                navigate(constants.CURSO)
              } else if (retryResult.dismiss === Swal.DismissReason.cancel) {
                // Volver al curso
                navigate(constants.CURSO)
              }
            });
          }
        } else {
          Swal.fire({
            title: "Error",
            text: response.data.message,
            icon: "error",
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: 'auteco_button primary'
            },
          });
        }
      }
    });
  };


  const todasRespondidas = examen?.preguntas?.every(
    pregunta => respuestas[pregunta.id] && respuestas[pregunta.id].length > 0
  );


  return (
    <div className='auteco_pagina-examen'>
      <Header />
      <div className='contenedor-cabecera'>
        <div className='imagen-examen'>
          {isLoading ? (
            <Loader />
          ) : (
            !error &&
            <div className="contenedor-imagen" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${examen?.imagen?.url})` }}>
              <div className='titulos'>
                <div className='titulo'>{examen?.titulo}</div>
                <div className='subtitulo'>{examen?.descripcion}</div>
              </div>
            </div>
          )}
        </div>
      </div>


      {!isLoading && !error && examen?.preguntas && (

        <div className='examen'>

          {examen.preguntas.map((pregunta, index) => (
            <div key={pregunta.id} className='pregunta-contenedor'>
              <div className='numero'>{index + 1}.</div>
              <div className='separador'>
                <div className='auteco_separador-vertical'></div>
              </div>
              <div className='pregunta'>
                <div className='texto'>{ConvertirSaltosDeLinea(pregunta.pregunta)}</div>
                <div className='opciones'>
                  {Object.keys(pregunta)
                    .filter(key => key !== 'id' && key !== 'pregunta')
                    .map(opcion => (
                      <div key={opcion} className='auteco_checkbox'>
                        <input
                          id={`pregunta-${pregunta.id}-opcion-${opcion}`}
                          type='checkbox'
                          checked={respuestas[pregunta.id]?.includes(opcion) || false}
                          onChange={() => handleChange(pregunta.id, opcion)}
                        />
                        <label
                          htmlFor={`pregunta-${pregunta.id}-opcion-${opcion}`}
                          className={respuestas[pregunta.id]?.includes(opcion) ? 'negrilla' : ''}
                        >
                          {ConvertirSaltosDeLinea(pregunta[opcion])}
                        </label>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          ))}
          <div className='boton-enviar'>
            <button
              className="auteco_button primary"
              onClick={handleEnviarRespuestas}
              disabled={!todasRespondidas}
            >
              Enviar
            </button>
          </div>
        </div>
      )}

      <Footer />

    </div>
  );
}

export default Examen;
